import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nProvider";

export const NotFoundPage = () => {
  const { dict, lang } = useI18n();
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4 py-16">
      <div className="text-center max-w-md">
        <p className="text-[11px] font-mono uppercase tracking-[0.24em] text-emerald-700">
          404
        </p>
        <h1 className="mt-3 text-3xl font-bold text-slate-900">{dict.not_found.title}</h1>
        <p className="mt-3 text-slate-600">{dict.not_found.description}</p>
        <Link
          to={`/${lang}`}
          data-testid="notfound-back-home"
          className="mt-6 inline-flex items-center bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-semibold px-5 py-3 rounded-sm"
        >
          {dict.not_found.back_home}
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
